import { useSelector } from 'react-redux';
import { LanguageLoader } from '../assets/languages';
import React from "react";
import { Link, useNavigate } from 'react-router-dom';

const NotFound = () =>
{
	const preferences = useSelector((state) => state.preferences);	
	const language = LanguageLoader(preferences.language);
	const navigate = useNavigate();

	return (
		<>
			<div className='text-end'>
				<Link to='/'><button className='btn'>بازگشت به صفحه اصلی</button></Link>
				<Link onClick={() => navigate(-1)}><button className='btn btn-secondary'>بازگشت</button></Link>
			</div>
			<div className="bg-center bg-not-found w-full h-[40rem] md:h-[30rem] bg-no-repeat relative text-center">
				<h3 className="absolute bottom-24 md:bottom-12 left-2 right-2">{language.ERROR["PAGE_NOT_FOUND"]}</h3>
			</div>
		</>
	);
}

export default NotFound;